export default __webpack_public_path__ + "media/Add.6e7553d5.svg";